import FacebookIconComponent from './facebookIcon.component';

export const facebookIconModule = {
	name: 'facebookIconComponent',
};

export default angular
	.module(facebookIconModule.name, [])
	.component('facebookIcon', new FacebookIconComponent()).name;
